import React, { useEffect, useState, useRef } from "react";
import "../css/updatejobs.css";
import { useLocation } from "react-router-dom";

const UpdateJobs = () => {



  return (
    <>
            <div>update actions</div>
    </>
  );
};

export default UpdateJobs;
